import { PageProps } from 'gatsby';
import { ContactSection } from '@/components/general/ContactSection';
import { Layout } from '@/components/general/Layout';
import { PageHeader } from '@/components/general/PageHeader';
import { Seo } from '@/components/general/Seo';
import { SecuritySection } from '@/components/page-sections/SecuritySection';
import { css } from '@emotion/react';
import { getScreen } from '@/styles/media-query';

const Page: React.FC<PageProps> = ({ location }) => (
  <Layout location={location}>
    <Seo
      title="IPO準備のセキュリティ対策｜監査法人・証券会社にも対応【Uniforce】"
      description="【Uniforce】IPO準備に必要な情報をハイレベルなセキュリティで保護。悪意ある攻撃や情報漏えい事故などのリスクを防止。定期的な診断と最新のセキュリティ対策を常時アップデート。"
    />
    <PageHeader
       en="SECURITY"
       title="安心のセキュリティ"
       readText={
        <>
          IPO準備業務の課題を解決し
          <br
            css={css`
              @media ${getScreen('pc')} {
                display: none;
              }
            `}
          />
          Uniforce IPO準備クラウドは、多くの監査法人や証券会社にも
          <br />
          ご利用いただけるセキュリティになっております。
        </>
      }
    />
    <SecuritySection />
    <ContactSection
      title1="Uniforce IPO準備クラウドで"
      title2="「IPOの準備を効率的」"
      title3="に"
      title4="進めませんか？"
      text="IPO準備クラウドの機能詳細や無料デモのご相談はこちら"
    />
  </Layout>
);

export default Page;
